import { createSlice } from "@reduxjs/toolkit";

const lapSlice = createSlice({
  name: "lap",
  initialState: {
    dynamos: {},
    lapDetails: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchDynamoRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDynamoSuccess: (state, action) => {
      const { dynamoCode, data } = action.payload;
      state.loading = false;
      state.dynamos[dynamoCode] = data;
      state.error = null;
    },
    fetchDynamoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchLAPDetailRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLAPDetailSuccess: (state, action) => {
      const { lapId, data } = action.payload;
      state.loading = false;
      state.lapDetails[lapId] = data;
      state.error = null;
    },
    fetchLAPDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDynamo: (state, action) => {
      const dynamoCode = action.payload;
      if (dynamoCode) {
        delete state.dynamos[dynamoCode];
      } else {
        state.dynamos = {};
      }
    },
    clearLAPDetail: (state, action) => {
      const lapId = action.payload;
      if (lapId) {
        delete state.lapDetails[lapId];
      } else {
        state.lapDetails = {};
      }
    },
  },
});

export const {
  fetchDynamoRequest,
  fetchDynamoSuccess,
  fetchDynamoFailure,
  fetchLAPDetailRequest,
  fetchLAPDetailSuccess,
  fetchLAPDetailFailure,
  clearDynamo,
  clearLAPDetail,
} = lapSlice.actions;

export default lapSlice.reducer;

